import { createSlice } from "@reduxjs/toolkit";

const cookieSlice = createSlice({
  name: "cookie",
  initialState: {
    isVisible: false,
    preferences: {
      necessary: true, // Her zaman true, disable edilemez
      analytics: false,
      marketing: false,
      functional: false,
    },
    hasConsented: false,
    lastUpdated: null,
  },
  reducers: {
    showCookieBanner: (state) => {
      state.isVisible = true;
    },
    hideCookieBanner: (state) => {
      state.isVisible = false;
    },
    acceptAllCookies: (state) => {
      state.preferences = {
        necessary: true,
        analytics: true,
        marketing: true,
        functional: true,
      };
      state.hasConsented = true;
      state.isVisible = false;
      state.lastUpdated = new Date().toISOString();
      
      // localStorage'a kaydet
      localStorage.setItem("cookieConsent", JSON.stringify({
        preferences: state.preferences,
        hasConsented: true,
        lastUpdated: state.lastUpdated
      }));
    },
    acceptNecessaryCookies: (state) => {
      state.preferences = {
        necessary: true,
        analytics: false,
        marketing: false,
        functional: false,
      };
      state.hasConsented = true;
      state.isVisible = false;
      state.lastUpdated = new Date().toISOString();
      
      localStorage.setItem("cookieConsent", JSON.stringify({
        preferences: state.preferences,
        hasConsented: true,
        lastUpdated: state.lastUpdated
      }));
    },
    updateCookiePreferences: (state, action) => {
      state.preferences = {
        ...state.preferences,
        ...action.payload,
        necessary: true // Necessary cookies her zaman true
      };
      state.hasConsented = true;
      state.isVisible = false;
      state.lastUpdated = new Date().toISOString();
      
      localStorage.setItem("cookieConsent", JSON.stringify({
        preferences: state.preferences,
        hasConsented: true,
        lastUpdated: state.lastUpdated
      }));
    },
    loadCookieConsent: (state) => {
      const savedConsent = localStorage.getItem("cookieConsent");
      if (savedConsent) {
        try {
          const parsedConsent = JSON.parse(savedConsent);
          state.preferences = parsedConsent.preferences;
          state.hasConsented = parsedConsent.hasConsented;
          state.lastUpdated = parsedConsent.lastUpdated;
          state.isVisible = false;
        } catch (error) {
          console.error("Cookie consent data not loaded:", error);
          state.isVisible = true;
        }
      } else {
        state.isVisible = true;
      }
    },
    resetCookieConsent: (state) => {
      state.preferences = {
        necessary: true,
        analytics: false,
        marketing: false,
        functional: false,
      };
      state.hasConsented = false;
      state.isVisible = true;
      state.lastUpdated = null;
      localStorage.removeItem("cookieConsent");
    }
  },
});

export const {
  showCookieBanner,
  hideCookieBanner,
  acceptAllCookies,
  acceptNecessaryCookies,
  updateCookiePreferences,
  loadCookieConsent,
  resetCookieConsent
} = cookieSlice.actions;

export default cookieSlice.reducer;